import script from "./HomeDirectorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDirectorComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeDirectorComponent.vue?vue&type=style&index=0&id=f1b3319a&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1b3319a"]])

export default __exports__